window.MMC = window.MMC || {};

/* Version 18.9.3 - CSS Mobile Grid Selector Fix */
MMC.version = '18.9.3';

/* Centralized asset registry */
MMC.Assets = {
  backgroundGradient: 'https://www.mysticmonkcoffee.com/cdn/shop/files/gradient_test_3small.png',
  loadImagePlaceholder: 'https://www.mysticmonkcoffee.com/cdn/shop/files/placeholder.png',
  icons: {
    arrow: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='8' viewBox='0 0 16 8' fill='none'%3E%3Cpath d='M1 1L8 7L15 1' stroke='%235c4428' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"
  }
};

/* Centralized ratio settings */
MMC.imageRatios = {
  coffee: { standard: '100%', withNotes: '80%', square: '100%' },
  product: { square: '100%', portrait: '116.67%' }
};

/* Debounce function */
function debounce(func, delay) {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
}

/* Initialization */
document.addEventListener('DOMContentLoaded', function() {
  console.log(`MMC Card System v${MMC.version} initializing...`);
  const components = [
    { name: 'Card Structure', init: fixCardStructure },
    { name: 'Flavor Labels', init: enhanceFlavorLabels },
    { name: 'Image Loading', init: enhanceImageLoading },
    { name: 'Roast Indicators', init: enhanceRoastSliders },
    { name: 'Mobile Scroll', init: initMobileScroll },
    { name: 'Mobile Grid', init: initMobileGrid },
    { name: 'Interaction Effects', init: initInteractionEffects }
    
  ];
  components.forEach(component => {
    try { console.log(`Initializing ${component.name}...`); component.init(); }
    catch (e) { console.error(`Failed to initialize ${component.name}:`, e); }
  });
  console.log(`MMC Card System v${MMC.version} initialized successfully`);
});

/** Fix card structure */
function fixCardStructure() {
  document.querySelectorAll('.coffee-image-wrapper').forEach(wrapper => {
    wrapper.style.position = 'relative';
    wrapper.style.overflow = 'visible';
    wrapper.style.containerType = 'inline-size';
    wrapper.style.containerName = 'coffee-image';
    const card = wrapper.closest('.coffee-product-card');
    if (card) {
      const gradientUrl = MMC.Assets.backgroundGradient;
      wrapper.style.setProperty('--gradient-url', `url(${gradientUrl})`);
      card.style.overflow = 'visible';
    }
  });

  document.querySelectorAll('.coffee-product-card').forEach(card => {
    card.style.overflow = 'visible';
    const badge = card.querySelector('.coffee-badge');
    if (badge) { badge.style.cssText = ''; }
    card.style.removeProperty('height');
    card.style.removeProperty('min-height');
    card.style.containerType = 'inline-size';
    card.style.containerName = 'coffee-card';

    const coffeeCard = card.querySelector('.coffee-card');
    if (coffeeCard) {
      coffeeCard.style.display = 'flex';
      coffeeCard.style.flexDirection = 'column';
      coffeeCard.style.minHeight = '100%';
      coffeeCard.style.flexGrow = '1';
    }

    const title = card.querySelector('.coffee-title a');
    if (title) {
      // Dynamic font/letter spacing adjustments (optional, keep if desired)
      // if (title.textContent.length > 30) { title.style.fontSize = '0.95em'; }
      // if (title.textContent.length > 40) { title.style.letterSpacing = '0'; }
    }

    const footer = card.querySelector('.coffee-footer');
    if (footer) {
      footer.style.position = 'relative';
      footer.style.marginTop = 'auto';
      footer.style.removeProperty('bottom');
      footer.style.removeProperty('left');
      footer.style.flexShrink = '0';
    }
  });
  console.log('Card structure optimized');
}

/** Enhance flavor labels */
function enhanceFlavorLabels() {
  document.querySelectorAll('.coffee-note span[data-flavor="true"]').forEach(label => {
    if (label.textContent.includes(' ')) {
      const words = label.textContent.split(' ');
      if (words.length === 2) { label.innerHTML = words.join('<br>'); }
      else if (words.length > 2) {
        const half = Math.ceil(words.length / 2);
        label.innerHTML = `${words.slice(0, half).join(' ')}<br>${words.slice(half).join(' ')}`;
      }
    }
  });
  // Hover effects are now handled purely in CSS if possible, or re-added in initInteractionEffects
  document.querySelectorAll('.coffee-note .note-icon').forEach(icon => {
    // Setting width/height via CSS is generally preferred for responsiveness
    // icon.setAttribute('height', '32'); icon.setAttribute('width', '32');
  });
  console.log('Flavor labels optimized');
}

/** Enhance image loading */
function enhanceImageLoading() {
  const preloadGradient = new Image(); preloadGradient.src = MMC.Assets.backgroundGradient;
  document.querySelectorAll('.coffee-image, .coffee-image-secondary').forEach(img => {
    img.classList.add('loading');
    img.addEventListener('error', function() {
      console.warn('Failed to load image:', this.src); this.src = MMC.Assets.loadImagePlaceholder; this.classList.remove('loading');
    });
    img.addEventListener('load', function() { this.classList.remove('loading'); this.classList.add('loaded'); });
    if (img.complete && img.naturalWidth > 0) { img.classList.remove('loading'); img.classList.add('loaded'); }
    else if (img.complete && img.naturalWidth === 0) {
      console.warn('Image loaded but seems broken:', img.src); img.src = MMC.Assets.loadImagePlaceholder; img.classList.remove('loading');
    }
  });
  console.log('Image loading enhanced');
}

/** Enhance roast sliders */
function enhanceRoastSliders() {
  document.querySelectorAll('.coffee-roast-slider').forEach(slider => {
    slider.style.visibility = 'visible'; slider.style.opacity = '0.9';
    const thumb = slider.querySelector('.coffee-roast-thumb');
    if (thumb) {
      // CSS handles hover effects
      // const onMouseEnter = debounce(() => { thumb.style.transform = 'translateX(-50%) scale(1.2)'; }, 20);
      // const onMouseLeave = debounce(() => { thumb.style.transform = 'translateX(-50%)'; }, 20);
      // slider.addEventListener('mouseenter', onMouseEnter); slider.addEventListener('mouseleave', onMouseLeave);
    }
    slider.setAttribute('aria-label', 'Coffee roast level');
  });
  console.log('Roast sliders enhanced');
}

/** Mobile scroll carousels */
function initMobileScroll() {
  // Only apply scroll to non-collection lists on mobile
  if (window.innerWidth < 768) {
    document.querySelectorAll('.product-list:not(.product-list--no-scroll)').forEach(list => {
      // Skip lists that are designated for grid or are within collection results
      if (list.classList.contains('plp-mobile-grid') || list.closest('.collection__results')) {
          list.classList.remove('product-list--mobile-scroll'); // Ensure scroll class is removed
          const indicator = list.parentNode.querySelector('.product-list__scroll-indicator');
          if (indicator && indicator.nextElementSibling === list) indicator.remove(); // Remove indicator if present
          return; // Skip to next list
      }

      // Apply scroll class
      list.classList.add('product-list--mobile-scroll');

      // Add scroll indicator logic (only if more than ~2 items visible)
      if (list.children.length > 2) { // Adjust threshold as needed
        let scrollIndicator = list.parentNode.querySelector('.product-list__scroll-indicator');

        // Check if indicator exists *and* is directly before the list
        if (!scrollIndicator || scrollIndicator.nextElementSibling !== list) {
           if (scrollIndicator) scrollIndicator.remove(); // Remove misplaced indicator
           scrollIndicator = document.createElement('div');
           scrollIndicator.className = 'product-list__scroll-indicator';
           scrollIndicator.innerHTML = '<span>Scroll to see more</span>';
           list.parentNode.insertBefore(scrollIndicator, list);

           // Add scroll listener only once
           if (!list.hasAttribute('data-scroll-listener-added')) {
                const onScroll = debounce(() => {
                    scrollIndicator.classList.toggle('is-hidden', list.scrollLeft > 50);
                }, 100);
                list.addEventListener('scroll', onScroll, { passive: true });
                list.setAttribute('data-scroll-listener-added', 'true');
           }
        } else {
            // Indicator exists and is correctly placed, ensure it's visible initially
            scrollIndicator.classList.remove('is-hidden');
            // Ensure listener is attached if somehow missed (defensive)
             if (!list.hasAttribute('data-scroll-listener-added')) {
                 const onScroll = debounce(() => {
                    scrollIndicator.classList.toggle('is-hidden', list.scrollLeft > 50);
                }, 100);
                list.addEventListener('scroll', onScroll, { passive: true });
                list.setAttribute('data-scroll-listener-added', 'true');
             }
        }
      } else {
          // Not enough items to scroll, remove indicator if it exists
          const indicator = list.parentNode.querySelector('.product-list__scroll-indicator');
          if (indicator && indicator.nextElementSibling === list) indicator.remove();
      }
    });
  } else {
      // On desktop, remove scroll class and indicators from all lists
      document.querySelectorAll('.product-list.product-list--mobile-scroll').forEach(list => {
          list.classList.remove('product-list--mobile-scroll');
          const indicator = list.parentNode.querySelector('.product-list__scroll-indicator');
          if (indicator && indicator.nextElementSibling === list) indicator.remove();
      });
  }
  console.log('Mobile scroll initialized/updated');
}


/** Initialize 2-up mobile grid */
function initMobileGrid() {
  // Target only collection page grids on mobile
  if (window.innerWidth < 768) {
    // Select lists within collection results or specifically marked for grid
    const mainProductLists = document.querySelectorAll('.collection__results .product-list, .collection-list-item__grid'); // Keep selection broad initially

    mainProductLists.forEach(list => {
      // Check if it's *intended* to be a grid (e.g., based on theme settings if available, or default for collections)
      // For now, assume all .collection__results .product-list should be grid on mobile.
      if (!list.closest('.collection__results')) return; // Only apply to collection results for now

      list.classList.add('plp-mobile-grid');
      list.classList.remove('product-list--mobile-scroll'); // Ensure no scroll class
      list.classList.remove('is-scrollable'); // Explicitly remove theme's scroll class

      // Remove scroll indicator if present
      const prevSibling = list.parentNode.querySelector('.product-list__scroll-indicator');
      if (prevSibling && prevSibling.nextElementSibling === list) { prevSibling.remove(); }

      // Apply mobile card class
      list.querySelectorAll('.coffee-product-card').forEach(card => {
        card.classList.add('coffee-product-card--mobile');
        // Eager load images likely visible in the grid
        const img = card.querySelector('.coffee-image');
        if (img) { img.setAttribute('loading', 'eager'); }
      });
    });
    console.log('Mobile 2-up grid initialized');
  } else {
     // On desktop, ensure grid classes are removed if they were added
     document.querySelectorAll('.product-list.plp-mobile-grid').forEach(list => {
         list.classList.remove('plp-mobile-grid');
         list.querySelectorAll('.coffee-product-card.coffee-product-card--mobile').forEach(card => {
             card.classList.remove('coffee-product-card--mobile');
         });
     });
  }
}

/** Initialize interactive effects */
function initInteractionEffects() {
  // Card hover (Badge shimmer - CSS handles transform)
  document.querySelectorAll('.coffee-product-card').forEach(card => {
    if (card.hasAttribute('data-hover-listener-added')) return;
    const badge = card.querySelector('.coffee-badge');
    if (!badge) return; // Only add listeners if badge exists

    const onCardMouseEnter = debounce(function() {
      badge.style.backgroundSize = '200% 100%'; // Trigger shimmer animation
    }, 20);
    const onCardMouseLeave = debounce(function() {
      badge.style.backgroundSize = '100% 100%'; // Reset for next hover
    }, 20);

    card.addEventListener('mouseenter', onCardMouseEnter);
    card.addEventListener('mouseleave', onCardMouseLeave);
    card.setAttribute('data-hover-listener-added', 'true');
  });

  // Flavor notes click (Prevent link navigation)
  document.querySelectorAll('.coffee-note').forEach(note => {
     if (note.hasAttribute('data-click-listener-added')) return;
     note.addEventListener('click', debounce(function(event) {
        // Prevent the click from bubbling up to the parent <a> tag
        event.stopPropagation();
        event.preventDefault(); // Stop the link navigation

        this.classList.toggle('active');
        // Optional: Add analytics tracking here
        // console.log('Selected flavor:', this.querySelector('span')?.textContent.trim());
     }, 50));
     note.setAttribute('data-click-listener-added', 'true');
  });
  console.log('Interaction effects initialized');
}

// Resize handler - Re-evaluate mobile grid/scroll
window.addEventListener('resize', debounce(function() {
  // Re-run initializers that depend on screen size
  initMobileGrid();
  initMobileScroll();

  // --- Recalculate Container Queries & Flex ---
  document.querySelectorAll('.coffee-product-card').forEach(card => {
    // Force container query recalculation (if needed, often CSS handles this)
    // card.style.containerType = ''; setTimeout(() => { card.style.containerType = 'inline-size'; }, 0);

    // Re-assert flex properties for inner card structure
    const coffeeCard = card.querySelector('.coffee-card');
    if (coffeeCard) {
      coffeeCard.style.display = 'flex'; coffeeCard.style.flexDirection = 'column';
      coffeeCard.style.minHeight = '100%'; coffeeCard.style.flexGrow = '1';
    }
     const footer = card.querySelector('.coffee-footer');
      if (footer) { footer.style.marginTop = 'auto'; footer.style.flexShrink = '0'; }
  });

  // Re-initialize interactions if needed (usually not necessary unless elements are added/removed dynamically)
  // initInteractionEffects(); // Consider if needed

}, 250), { passive: true });

document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.acclinks h2 a, .acclinks h3 a');
  
  accordionHeaders.forEach(function(header) {
    header.addEventListener('click', function(e) {
      e.preventDefault();
      const content = this.parentElement.nextElementSibling;
      
      if (content.style.display === 'none' || content.style.display === '') {
        content.style.display = 'block';
      } else {
        content.style.display = 'none';
      }
      // MMC 1.1.1: lets the CSS chevron show open/closed
      const item = this.closest('.acclinks');
      if (item) item.classList.toggle('is-open', content.style.display === 'block');
    });
  });
});
